import React from 'react';

import LineChartMonthlyUsers from "../graphs/lineChartMonthlyUsers";
import LineChartMonthlyNotices from "../graphs/lineChartMonthlyNotices";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import NavBarMenu from '../NavBarMenu';
import FooterMenu from '../FooterMenu';

function Monthly() {
    return (
      <>
        <NavBarMenu />
        <main>
            <Container fluid>
            <Row className="display-flex">
                <Col>
                    <LineChartMonthlyUsers/>
                </Col>
            </Row>
            {/* <Row className="display-flex">
                <Col>
                    <LineChartMonthlyNotices/>
                </Col>
            </Row> */}
            </Container>
        </main>
        <FooterMenu />
      </>
    );
}
export default Monthly